/**
 * GroovLens cover presets — curated color + gradient palettes for the
 * Crate Cover Picker modal. Values chosen to match the app's neon /
 * night-club identity established in the design guidelines. Each entry
 * is durable: adding new ones is safe, removing existing ones may leave
 * previously-saved crate covers pointing at a stale id but the raw hex
 * value is persisted so those covers still render.
 */

export const COLOR_PRESETS = [
  { id: 'neon-magenta', label: 'Neon Magenta', color: '#FF3EA5' },
  { id: 'electric-cyan', label: 'Electric Cyan', color: '#18C7B8' },
  { id: 'sunset-amber', label: 'Sunset Amber', color: '#FFB24A' },
  { id: 'acid-lime', label: 'Acid Lime', color: '#C8FF2E' },
  { id: 'deep-violet', label: 'Deep Violet', color: '#5F3DC4' },
  { id: 'club-red', label: 'Club Red', color: '#FF4D5B' },
  { id: 'midnight-blue', label: 'Midnight Blue', color: '#1A2749' },
  { id: 'vinyl-black', label: 'Vinyl Black', color: '#0F1116' },
  { id: 'peach-fizz', label: 'Peach Fizz', color: '#FF8E8E' },
  { id: 'chrome-silver', label: 'Chrome Silver', color: '#C9CBD1' },
  { id: 'rave-green', label: 'Rave Green', color: '#2EE59D' },
  { id: 'jazz-brass', label: 'Jazz Brass', color: '#B5893D' },
];

export const GRADIENT_PRESETS = [
  { id: 'sunset-deck', label: 'Sunset Deck', from: '#FF3EA5', to: '#FFB24A', angle: 135 },
  { id: 'bassline', label: 'Bassline', from: '#5F3DC4', to: '#0F1116', angle: 180 },
  { id: 'vaporwave', label: 'Vaporwave', from: '#FF3EA5', to: '#18C7B8', angle: 135 },
  { id: '808-heat', label: '808 Heat', from: '#FF4D5B', to: '#5F3DC4', angle: 160 },
  { id: 'ibiza-dawn', label: 'Ibiza Dawn', from: '#FFB24A', to: '#18C7B8', angle: 200 },
  { id: 'warehouse', label: 'Warehouse', from: '#1A2749', to: '#0F1116', angle: 135 },
  { id: 'jungle', label: 'Jungle', from: '#2EE59D', to: '#1A2749', angle: 145 },
  { id: 'chrome-city', label: 'Chrome City', from: '#C9CBD1', to: '#1A2749', angle: 180 },
];

/**
 * Suggested emoji picks curated for music/DJ context. Users can still
 * type any emoji via a native input, but these are the one-tap shortcuts.
 */
export const EMOJI_PICKS = [
  '🎧', '🎵', '🎶', '💿', '📀', '🎙️',
  '🎤', '🎹', '🎸', '🥁', '🎺', '🎷',
  '🔊', '⚡', '🔥', '🌌', '🌚', '🌙',
  '💎', '👑', '🎯', '🎪', '🏴', '🎮',
];

/**
 * Solid color background choices for emoji covers (matches COLOR_PRESETS
 * shape but a shorter curated list to fit inline in the picker UI).
 */
export const EMOJI_BG_PRESETS = [
  '#0F1116', '#FF3EA5', '#18C7B8', '#FFB24A', '#5F3DC4', '#C8FF2E',
  '#FF4D5B', '#2EE59D', '#1A2749', '#B5893D',
];
